
// ManageSubscription.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { publicAxios } from "../../../config/apiConfig";
import { toast } from "react-toastify";

function useQuery() { return new URLSearchParams(useLocation().search); }

export default function ManageSubscription() {
    const query = useQuery();
    const token = query.get('token');
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [subscriber, setSubscriber] = useState(null);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!token) { setError('Invalid link'); setLoading(false); return; }
        publicAxios.get(`by-manage-token?token=${encodeURIComponent(token)}`)
            .then(res => setSubscriber(res.data))
            .catch(err => setError('Invalid manage link'))
            .finally(() => setLoading(false));
    }, [token]);

    const handleSave = async () => {
        if (!subscriber) return;
        setSaving(true);
        try {
            const payload = {
                token,
                enabled: subscriber.enabled,
                wantsOffers: subscriber.wantsOffers,
                wantsNewProducts: subscriber.wantsNewProducts,
                wantsDiscounts: subscriber.wantsDiscounts
            };
            await publicAxios.post('update-by-manage-token', payload, { headers: { "X-Frontend-Base-Url": window.location.origin } });
            toast.success('Preferences saved');
        } catch (e) {
            toast.error('Save failed');
        } finally { setSaving(false) }
    };

    const handleUnsubscribe = async () => {
        if (!window.confirm('Unsubscribe?')) return;
        try {
            await publicAxios.get(`unsubscribe?token=${token}`);
            toast.success('Unsubscribed');
            navigate(`/unSubscription?token=${token}`);
        } catch (e) {
            toast.error('Failed to unsubscribe');
        }
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
            <div className="w-full max-w-lg bg-white p-6 rounded-2xl shadow-lg">
                {/* Title */}
                <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                    Manage Subscription
                </h2>

                {/* Email */}
                <p className="mb-6 text-center text-gray-700">
                    Email: <strong>{subscriber.email}</strong>
                </p>

                {/* Preferences */}
                <div className="space-y-4 text-left">
                    <label className="flex items-center">
                        <input
                            type="checkbox"
                            checked={subscriber.wantsOffers}
                            onChange={e =>
                                setSubscriber({ ...subscriber, wantsOffers: e.target.checked })
                            }
                            className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                        />
                        <span className="ml-3">Offers & promotions</span>
                    </label>

                    <label className="flex items-center">
                        <input
                            type="checkbox"
                            checked={subscriber.wantsNewProducts}
                            onChange={e =>
                                setSubscriber({ ...subscriber, wantsNewProducts: e.target.checked })
                            }
                            className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                        />
                        <span className="ml-3">New product announcements</span>
                    </label>

                    <label className="flex items-center">
                        <input
                            type="checkbox"
                            checked={subscriber.wantsDiscounts}
                            onChange={e =>
                                setSubscriber({ ...subscriber, wantsDiscounts: e.target.checked })
                            }
                            className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                        />
                        <span className="ml-3">Discounts & offers</span>
                    </label>
                </div>

                {/* Actions */}
                <div className="flex flex-col sm:flex-row gap-3 mt-8">
                    <button
                        onClick={handleSave}
                        disabled={saving}
                        className="flex-1 px-4 py-3 bg-green-600 text-white rounded-lg font-semibold shadow hover:bg-green-700 transition"
                    >
                        {saving ? "Saving..." : "Save"}
                    </button>
                    <button
                        onClick={handleUnsubscribe}
                        className="flex-1 px-4 py-3 bg-red-600 text-white rounded-lg font-semibold shadow hover:bg-red-700 transition"
                    >
                        Unsubscribe
                    </button>
                </div>
            </div>
        </div>

    );
}
